<div class="header">
  <div class="content">
    <div class="contentInner">
      <div class="pageTitle" appReveal>
        <h1 class="headline">Dash Enterprise Client Authorization</h1>
      </div>
    </div>
  </div>
</div>
<div class="content">
  <div class="contentInner">
    <div *ngIf="!hasCode()">
      <p>Use this service to find the ids of your calendars when connecting to Microsoft 365 using a busioness/personal account connection, or to Google Workspace using
        a standard/personal account connection.  You will need these ids if centrally configuring Dash using MDM or our web dashboard.
        </p>
      <p>If you're
        connecting using a Microsoft 365 Enterprise Application or Google Workspace Service Account connection, you don't need this page - use the email address of your meeting rooms as id's.</p>

      <p>Please select the service you use to manage your calendars:</p>

      <p class="providerChooser"><a href="{{ microsoftAuthUrl() }}">Microsoft 365</a><a href="{{ googleAuthUrl() }}">Google Workspace</a></p>
    </div>
    <div *ngIf="hasCode()">
      <div class="loaderContainer" *ngIf="!hasResponse()">
        <div class="loader"></div>
      </div>
      <h1>Calendars</h1>
      <p>Use these calendars to set <i>calendar</i> (the calendar Dash will display), and the calendars searched in <i>findFreeRooms</i></p>
      <div class="calendarTableContainer">
        <div class="calendarTableRow">
          <div class="calendarId">ID</div>
          <div class="calendarName">Name</div>
        </div>
        <div class="calendarTableRow" *ngFor="let calendar of calendars; index as i;">
          <div class="calendarId">{{calendar.id}}</div>
          <div class="calendarName">{{calendar.title}}</div>
        </div>
      </div>
    </div>
  </div>
</div>
